import React, {
    ReactElement,
} from "react";
import { Form } from "react-bootstrap";
import ExpandingSection from "../../../../components/expanding-section/ExpandingSection";
import WorkflowServiceApiSelector from "./ApiSelector";
import { Json } from "./base";

export default function WorkflowServiceAnswers({ json, onChange, rootJson }: {
    rootJson: Json;
    json: Json;
    onChange: (current: Json) => void;
}): ReactElement {
    return (
        <ExpandingSection title="Answers">
            <Form.Group className="mb-3">
                <Form.Label className="fw-bolder">Get Answer</Form.Label>
                <Form.Text className="d-block">
                    Get Answer API
                </Form.Text>
                <WorkflowServiceApiSelector
                    rootJson={rootJson}
                    json={json?.getAnswer as Json}
                    onChange={value => onChange({
                        ...json,
                        getAnswer: value,
                    })}

                />
            </Form.Group>

        </ExpandingSection>
    );
}
